var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('MainNav'),_c('ShopTitle',{attrs:{"title":"Shop"}}),(_vm.product)?_c('ShopProduct',{attrs:{"product":_vm.product}}):_vm._e(),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }